import { routeUrls } from 'root/src/shared/descriptions/routes/routeUrls';
export const newRoutes = {
    [routeUrls.giveawayHistory()]: {
        url: routeUrls.giveawayHistory(),
        modules: [],
    },
    [routeUrls.giveawayRewards()]: {
        url: routeUrls.giveawayRewards(),
        modules: [],
    },
    [routeUrls.drops()]: {
        url: routeUrls.drops(),
        modules: [],
    },
    [routeUrls.audienceTargeting()]: {
        url: routeUrls.audienceTargeting(),
        modules: [],
    },
    [routeUrls.reviewClips()]: {
        url: routeUrls.reviewClips(),
        modules: [],
    },
    [routeUrls.brandUsers()]: {
        url: routeUrls.brandUsers(),
        modules: [],
    },
    '/creators/:id': {
        url: '/creators/:id',
        modules: [],
    },
    '/creators/yt/:id': {
        url: '/creators/yt/:id',
        modules: [],
    },
    '/creators/tiktok/:id': {
        url: '/creators/tiktok/:id',
        modules: [],
    },
    [routeUrls.addCampaign()]: {
        url: routeUrls.addCampaign(),
        modules: [],
    },
    [routeUrls.steamSales()]: {
        url: routeUrls.steamSales(),
        modules: [],
    },
    [routeUrls.keysAndProducts()]: {
        url: routeUrls.keysAndProducts(),
        modules: [],
    },
    '/battle-passes/:id': {
        url: '/battle-passes/:id',
        modules: [],
    },
    [routeUrls.battlePasses()]: {
        url: routeUrls.battlePasses(),
        modules: [],
    },
    [routeUrls.creatorDashboard()]: {
        url: routeUrls.creatorDashboard(),
    },
    [routeUrls.ambassadorProgram()]: {
        url: routeUrls.ambassadorProgram(),
        modules: [],
    },
    [routeUrls.creatorsLeaderboard()]: {
        url: routeUrls.creatorsLeaderboard(),
        modules: [],
    },
    [routeUrls.applications()]: {
        url: routeUrls.applications(),
        modules: [],
    },
    [routeUrls.application(':id')]: {
        url: routeUrls.application(':id'),
        modules: [],
    },
    [routeUrls.satisfactionSurvey()]: {
        url: routeUrls.satisfactionSurvey(),
        modules: [],
    },
    [routeUrls.authPopupCallback()]: {
        url: routeUrls.authPopupCallback(),
        modules: [],
    },
    [routeUrls.editCreatorDare(':id')]: {
        url: routeUrls.editCreatorDare(':id'),
        modules: [],
    },
};
